<template>
<div>
    <v-toolbar app color="black" dark>
        <v-toolbar-title data-cy="titleBtn">
            <img class="menuLogo ml-0" src="../assets/images/LogoCAMON.png" style="height: 45px" @click="gotoHome()" />
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-layout v-if="isDesktopMode()" align-start row justify-center class="red darken-2 p-0 m-0" style="border-radius: 10px 10px 10px 10px"><span class="white--text"><strong>CAM-ON Videos</strong>
            </span>
        </v-layout>
        <v-spacer></v-spacer>
        <v-icon class="mr-4" @click="goBack()">arrow_back</v-icon>
    </v-toolbar>

    <v-layout align-start row wrap justify-center class="mt-1">
        <v-flex flex xs12 sm12 md12 lg12 v-if="loaded">
	            <vimeo-player :autoplay=true :background=true :title=false ref="player" :video-url="videoURL" @ready="onReady" :player-height="height" :player-width="width"></vimeo-player>
        </v-flex>
    </v-layout>
    <v-footer v-if="isMobileMode()" fixed class="grey darken-2" style="height: 30px; padding: 10px">
        <v-layout align-start row wrap justify-center class="orange  p-0 m-0" style="border-radius: 10px 10px 10px 10px"><span class="black--text"><strong>CAM-ON Videos</strong>
            </span>
        </v-layout>
    </v-footer>
</div>
</template>

<script>
 import vueVimeoPlayer from 'vue-vimeo-player'


export default {
    components: {
    },
    name: 'Camon-Player',

    data() {
        return {
           videoID: '',
           videoURL: '',
			height: '',
            width: window.innerWidth,
			options: {
				muted: true,
	      			autoplay: true,
			},
			playerReady: false,
            loaded: false
        };
    },

    mounted() {
        this.videoURL = "https://vimeo.com/" + (this.$route.params.vimeoURL.replace("|","/"));
        this.width = window.innerWidth;
        console.log(this.videoURL);
        //console.log(this.width);
        this.loaded = true;
    },

    methods: {
        isMobileMode: function () {
            let res = this.$vuetify.breakpoint.name === 'xs';
            return res;
        },
        isDesktopMode: function () {
            return !this.isMobileMode();
        },
        onReady() {
			this.playerReady = true
		},
		play () {
			this.$refs.player.play()
		},
		pause () {
			this.$refs.player.pause()
		},
        goBack(){
           window.history.back();
        },
         gotoHome() {
            this.$router.push('/');
        },

    }
};
</script>

<style scoped>
td {
    height: 10px !important;
    _background-image: linear-gradient(60deg, grey, lightgray);
}

.ok {
    text-align: center;
    color: white;
    background-color: green;
    border-radius: 0px 0px 3px 3px;
}

.frazioniTitle {
    text-align: left;
    background-color: lightgrey;
    border-radius: 0px 0px 3px 3px;
}

.frazioniValue {
    text-align: center;
    background-color: white;
    border-radius: 0px 0px 3px 3px;
    border-bottom: 1px solid lightgray;
}

.frazioniTitleFinale {
    text-align: center;
    background-color: orange;
    color: black;
    font-style: italic;
    _border: 1px solid lightgray;
    border-radius: 0px 0px 5px 5px;
    font-weight: bold;
}

.frazioniTitleFinalePrimo {
    text-align: right;
    background-color: orange;
    color: black;
    font-style: italic;
    _border: 1px solid lightgray;
    border-radius: 0px 0px 5px 5px;
    font-weight: bold;
}

.frazioniTitleFinaleAltri {
    background-color: rgb(182, 177, 177);

}

.frazioniTitlePos {
    text-align: right;
    background-color: rgb(90, 89, 89);
    color: white;
    font-style: italic;
    border-radius: 5px 0px 0px 5px;
    font-weight: bold;
}

.cardUp {
    background-color: rgb(0, 0, 0);
    color: white;
    _border: 1px solid lightgray;
    border-radius: 20px 10px 0px 0px;
}

.cardDown {
    background-color: rgb(0, 0, 0);
    color: white;
    _border: 1px solid lightgray;
    border-radius: 0px 0px 10px 10px;
}
</style>
